import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../DiscountOffer.module.css';
import { Typography } from '../../../components/Typography/typography';
import Button from '../../../components/UI/Buttons/Button/Button';

const CancelSection = ({ onProceedToCancel, loading }) => {
    const { t } = useTranslation();
    
    return (
        <div className={styles.cancelSection}>
            <div className={styles.cancelContainer}>
                <Typography
                    title={t('discount_offer.still_cancel_question')}
                    fontSize={18}
                    weight="500"
                    color="#333"
                />
                <Button 
                    className={styles.cancelButton} 
                    color="danger"
                    onClick={onProceedToCancel}
                    disabled={loading}
                >
                    {t('discount_offer.proceed_to_cancel')}
                </Button>
            </div>
        </div>
    );
};

export default CancelSection; 